var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPushPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.003,
    height: 20,
    viewBox: "0 0 16.003 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_1_",
    "data-name": "file (1)",
    transform: "translate(-44.97 .007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44123",
    "data-name": "Group 44123",
    transform: "translate(56.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44122",
    "data-name": "Group 44122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48725",
    "data-name": "Path 48725",
    d: "M356.324,0V3a1.367,1.367,0,0,0,1.365,1.365h3Z",
    transform: "translate(-356.324)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44125",
    "data-name": "Group 44125",
    transform: "translate(44.97 -.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44124",
    "data-name": "Group 44124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48726",
    "data-name": "Path 48726",
    d: "M58.088,5.674a2.671,2.671,0,0,1-2.623-2.7V0h-7.9a2.512,2.512,0,0,0-1.887.656,2.772,2.772,0,0,0-.7,2V17.291a2.671,2.671,0,0,0,2.623,2.7H58.35a2.671,2.671,0,0,0,2.623-2.7V5.674Zm-4.721,8.781H48.645V13.1h4.721ZM57.3,11.212H48.645V9.861H57.3Z",
    transform: "translate(-44.97 .007)",
    fill: "#f2f2f2"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPushPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_push_pin.ffe70c1641d226c4c5c40e3f1f427b28.svg";